<template>
    <div class="rater">
        <div class="raterBoxGroup" @click.prevent="show = !show">
            <div :id="'avg' + genId" class="ratingBox" :class="{rating0: topVal == 0, rating1: topVal >= 1 && topVal <= 1.5, rating2: topVal > 1.5 && topVal <= 2.5, rating3: topVal > 2.5 && topVal <=3.5, rating4: topVal > 3.5 && topVal <= 4.5, rating5: topVal > 4.5}">
                <span  v-html="chkHeart(Math.round(topVal))"></span> <!-- v-show="show || ratingAvg == 0" -->
            </div>
          <!--   <div v-show="ratingMy > 0 || show" ref="myRating" class="ratingBox" :class="{rating0: ratingMy == 0, rating1: ratingMy == 1, rating2: ratingMy == 2, rating3: ratingMy == 3, rating4: ratingMy == 4, rating5: ratingMy == 5}">
                <span >{{ratingMy | rateFilter2}}</span> 
            </div> -->
        </div>
        <div v-show="show" class="raterBG has-text-white is-size-7" @click.prevent="dummy">
           <div class="is-inline-block top2">
                <!-- <div class="left2">Average Rating: <span class="has-text-coolGreen">...............</span></div> -->
                <div class="is-inline left10">Rating:</div>
                <div class="ratingBox2 top1 rating1" :class="{ratingSelected: myRating == 1}" @click.prevent="selectIt(1)"><span>1</span></div>
                <div class="ratingBox2 top1 rating2" :class="{ratingSelected: myRating == 2}" @click.prevent="selectIt(2)"><span>2</span></div>
                <div class="ratingBox2 top1 rating3" :class="{ratingSelected: myRating == 3}" @click.prevent="selectIt(3)"><span>3</span></div>
                <div class="ratingBox2 top1 rating4" :class="{ratingSelected: myRating == 4}" @click.prevent="selectIt(4)"><span>4</span></div>
                <div class="ratingBox2 top1 rating5" :class="{ratingSelected: myRating == 5}" @click.prevent="selectIt(5)"><span>5</span></div>
                <div v-if="isCollab" class="is-inline-block avgRtgLabel">Avg:</div>
           </div>
          <!--  <div class="is-inline-block">
               <div class="top2">
                   
               </div>
                <div>&nbsp;</div>
           </div> -->
           <div v-if="bottomBox" class="raterBoxGroup2 has-background-black top2">
            <div class="top10">
                <div class="is-inline-block ">Pub. Avg:</div>
                <div :id="'avgP' + genId" class="ratingBox3 is-inline-block" :class="{rating0: botVal == 0, rating1: botVal >= 1 && botVal <= 1.5, rating2: botVal > 1.5 && botVal <= 2.5, rating3: botVal > 2.5 && botVal <=3.5, rating4: botVal > 3.5 && botVal <= 4.5, rating5: botVal > 4.5}">
                   <span>{{Math.round(botVal)}}</span>
                </div>
            </div>
           </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ratingMy: {
                type: Number,
                default: 0
            },
            topBox: {
                type: Number,
                default: 0
            },
            bottomBox: {
                type: Number,
                default: 0
            },
          /*   ratingMemAvg: {
                type: Number,
                default: 0
            }, */
            isCollab: {
                type: Boolean,
                default: true
            }
        },
        data: function() {
            return {
                show: false,
                topVal: this.topBox,
                botVal: this.bottomBox,
                myRating: this.ratingMy
            }
        },

        methods: {
            selectIt: function(val){
                this.myRating = val

                
                var self = this;

                function w(d){
                    
                    az.addRemSpinner(false, 'id', `avg${self.genId}`)
                    self.ratingAvg = d.avgRating

                    if(self.$parent.componentName != 'cardShared'){
                      
                       
                        if(!self.isCollab)
                            self.ratingAvg = val;


                        var id0 = self.$parent.$parent.$parent.$parent.conts.aliasTgtId || self.$parent.$parent.$parent.$parent.conts.id
                        for(var i=0; i < self.$root.app.cards.length; i++){
                            if(self.$root.app.cards[i].id == self.$parent.$parent.$parent.id){
                                //Rating
                               /*  if(self.isCollab){
                                   alert('here')
                                    let tg = self.$root.app.cards[i].myRatings.find(e => {
                                        return e.collabId == self.$parent.$parent.$parent.$parent.conts.collabId
                                    })
                                    if(tg){
                                        tg.rating = val
                                        var t = self.$parent.$parent.$parent.item.myRatings.find(n => {
                                            return n.collabId == self.$parent.$parent.$parent.$parent.conts.collabId
                                        }).rating = val
                                    } else {
                                        self.$root.app.cards[i].myRatings.push({collabId: self.$parent.$parent.$parent.$parent.conts.collabId, rating: val} )
                                    }
                                } else {  *///use bundle id instead of collabId
                                    
                                    let tg = self.$root.app.cards[i].myRatings.find(e => {
                                        return e.collabId == id0
                                        
                                    })
                                    if(tg){
                                      
                                        tg.rating = val
                                        self.$parent.$parent.$parent.item.myRatings.find(n => {
                                            return n.collabId == id0
                                        }).rating = val
                                    } else {
                                        self.$root.app.cards[i].myRatings.push({collabId: id0, rating: val} )
                                    }
                                    self.topVal = val
                               /*  } */
                                //Avg Rating
                                if(self.isCollab){
                                    
                                    let tg2 = self.$root.app.cards[i].avgRatings.find(e => {
                                        return e.collabId == id0
                                    })

                                    if(tg2){
                                      
                                        tg2.rating = d.avgRating
                                        self.$parent.$parent.$parent.item.avgRatings.find(n => {
                                            return n.collabId == id0
                                        }).rating = d.avgRating
                                    } else {
                                        self.$root.app.cards[i].avgRatings.push({collabId: id0, rating: d.avgRating} )
                                    }

                                   
                                //Member avg
                                   
                                    let tg5 = self.$root.app.cards[i].avgMemRatings.find(e => {
                                        return e.collabId == id0
                                    })
                                  
                                   
                                    if(tg5){
                                        
                                        tg5.rating = d.memberAvg
                                        self.$parent.$parent.$parent.item.avgMemRatings.find(n => {
                                            return n.collabId == id0
                                        }).rating = d.memberAvg
                                    } else {
                                        self.$root.app.cards[i].avgMemRatings.push({collabId: id0, rating: d.memberAvg} )
                                    }
                                    self.topVal = d.memberAvg

                                   

                                } else {
                                    let tg2 = self.$root.app.cards[i].avgRatings.find(e => {
                                        return e.collabId == self.$parent.$parent.$parent.$parent.conts.id
                                    })

                                    if(tg2){
                                       
                                        tg2.rating = val
                                        self.$parent.$parent.$parent.item.avgRatings.find(n => {
                                            return n.collabId == self.$parent.$parent.$parent.$parent.conts.id
                                        }).rating = d.avtRating
                                    } else {
                                        self.$root.app.cards[i].avgRatings.push({collabId: self.$parent.$parent.$parent.$parent.conts.id, rating: val} )
                                    }
                                }
                                break;
                            }
                        }

                    } else {

                        //find card in cards and change
                        var theCard = self.$root.app.cards.find(e => {
                            return e.id == self.$parent.item.id
                        })

                        var id0 = self.$parent.$parent.conts.aliasTgtId || self.$parent.$parent.conts.id

                        let tg3 = self.$parent.item.myRatings.find(e => {
                            return e.collabId == id0
                        })
                        if(tg3){
                            tg3.rating = val
                        } 
                      

                        if(theCard){
                            let tg7 = theCard.myRatings.find(e => {
                                return e.collabId == id0    
                            })
                            
                            if(tg7){
                                tg7.rating = val
                            } else {
                                theCard.myRatings.push({collabId: id0, rating: val} )
                            }
                        }

                    //////////////

                        let tg4 = self.$parent.item.avgRatings.find(e => {
                            return e.collabId == self.$parent.$parent.conts.id
                        })
                        if(tg4){
                            tg4.rating = d.avgRating
                        } 
                        self.topVal = d.avgRating
                        //
                        if(theCard){
                            let tg8 = theCard.avgRatings.find(e => {
                                return e.collabId == id0    
                            })
                            

                            if(tg8){
                                tg8.rating = d.avgRating
                            } else {
                                theCard.avgRatings.push({collabId: id0, rating: d.avgRating} )
                            }
                        }

                     
                    }
                }

                function n(){
                    az.addRemSpinner(false, 'id', `avg${self.genId}`)
                }

                az.addRemSpinner(true, 'id', `avg${self.genId}`)

                if(self.$parent.componentName == 'cardShared'){
                    var isMember = false
                    if(this.isCollab){
                        self.$parent.$parent.groupMembers.forEach(e => {
                            if(e.id_CUSTOMER == self.$root.app.userAttrs.sub || e.owner == self.$root.app.userAttrs.sub){
                                isMember = true
                            }
                        })
                    }
                }

                if(self.$parent.componentName != 'cardShared'){
                    this.$root.app.apiClient.put('subs/data/rating', {acl: this.$parent.$parent.$parent.$parent.conts.collabId, isCollab: false, id_CARDS: this.$parent.$parent.$parent.id, id_COLLAB: this.$parent.$parent.$parent.$parent.conts.aliasTgtId || this.$parent.$parent.$parent.$parent.conts.id, rating: val, id_BUNDLES: this.$parent.$parent.$parent.$parent.conts.aliasTgtId || this.$parent.$parent.$parent.$parent.conts.id, isPublic: this.$parent.$parent.$parent.$parent.conts.isPublic}, w, n)
                } else {
                    this.$root.app.apiClient.put('subs/data/rating', {doMemAvg: isMember ? self.$parent.$parent.conts.collabId : false, isCollab: false, id_CARDS: this.$parent.item.id, id_COLLAB: this.$parent.$parent.conts.aliasTgtId || this.$parent.$parent.conts.id, rating: val, id_BUNDLES: this.$parent.$parent.conts.id, isPublic: true }, w, n)
                }
                this.show = false
            },

            dummy: function(e){
                e.preventDefault()
                e.stopPropagation()
                return true
            },
            chkHeart(val){
                if(val == 0){
                    if(!this.show){
                        return '<i class="fas fa-star" style="position: relative; top: 0; right: 6px; font-size: 18px"></i>' 
                    }
                    return  '-'
                } else {
                    return Math.round(val)
                }
            }
        },

        computed: {
            genId: function(){
                if(this.$parent.componentName == 'cardShared'){
                    return this.$parent.cardInfo.id
                } else {
                    return this.$parent.$parent.$parent.id
                }
            }
        },

        filters: {
            
            rateFilter2: function(val){
                if(val == 0){
                    return '-'
                } else {
                    return val
                }
            }

        }
    }
</script>